import React from 'react';
import { useTranslation } from 'react-i18next';
import { PaymentFormDetails } from "../../components/PaymentFormDetails";

const PaymentMethodSelector = ({ paymentMethod, setPaymentMethod, formErrors, onValidationChange }) => {
  const { t } = useTranslation();

  return (
    <div className="mb-6">
      <div className="mb-4 rounded flex items-center justify-center">
           <PaymentFormDetails formErrorParent={formErrors} onValidationChange={onValidationChange} />
      </div>
    </div>
  );
};

export default PaymentMethodSelector;